import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import ConservationPage from "./src/conservation/ConservationPage";
import "./index.css";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <StrictMode>
    <ConservationPage />
  </StrictMode>,
);
